module.exports = __webpack_public_path__ + "img/healthPro4-EN.b65c6ddf.png";